import { createSlice } from "@reduxjs/toolkit";

interface SpecialAddModalState {
  isOpen: boolean;
}

const initialState: SpecialAddModalState = {
  isOpen: false,
};

const specialAddModalSlice = createSlice({
  name: "specialAddModal",
  initialState,
  reducers: {
    setOpenSpecialAddModal: (state, action) => {
      state.isOpen = action.payload;
    },
  },
});
export const { setOpenSpecialAddModal } = specialAddModalSlice.actions;
export default specialAddModalSlice.reducer;
